import React from 'react';

export default function Divider({ thickness }) {
  return (
    <div style={{ borderBottom: `${thickness || '5px'} solid #212121` }} />
  );
}
